import React, { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Edit2, Check, X } from 'lucide-react';

const fmt = (n) => new Intl.NumberFormat('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);

const parseDecimal = (val) => {
  if (val === '' || val === undefined || val === null) return 0;
  if (typeof val === 'number') return val;
  let str = String(val).trim();
  if (str.includes(',') && str.includes('.')) {
    str = str.replace(/\./g, '').replace(',', '.');
  } else if (str.includes(',')) {
    str = str.replace(',', '.');
  }
  const n = parseFloat(str);
  return isNaN(n) ? 0 : n;
};

export default function InlinePriceEditor({ value, onSave, label, suffix = '', className = '' }) {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValueStr, setTempValueStr] = useState(value ? String(value).replace('.', ',') : '');

  useEffect(() => {
    setTempValueStr(value ? String(value).replace('.', ',') : '');
  }, [value, isEditing]);

  const handleSave = () => {
    onSave(parseDecimal(tempValueStr));
    setIsEditing(false);
  };

  const handleCancel = () => {
    setTempValueStr(value ? String(value).replace('.', ',') : '');
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div className={`flex items-center gap-1.5 ${className}`}>
        {label && <span className="text-[10px] text-[#8C6208] font-bold">{label}</span>}
        <Input 
          type="text"
          inputMode="decimal"
          className="h-6 w-24 text-[10px] border-[#8C6208] bg-white px-1.5 focus-visible:ring-1 focus-visible:ring-[#8C6208]"
          value={tempValueStr}
          placeholder="Rp..."
          onChange={e => setTempValueStr(e.target.value)}
          autoFocus
          onKeyDown={e => {
            if (e.key === 'Enter') handleSave();
            if (e.key === 'Escape') handleCancel();
          }}
        />
        {suffix && <span className="text-[10px] text-muted-foreground">{suffix}</span>}
        <button onClick={handleSave} className="text-green-600 hover:text-green-700 bg-green-50 p-1 rounded-sm"><Check className="w-3 h-3" /></button>
        <button onClick={handleCancel} className="text-red-500 hover:text-red-600 bg-red-50 p-1 rounded-sm"><X className="w-3 h-3" /></button>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-1.5 group cursor-pointer ${className}`} onClick={() => setIsEditing(true)}>
      {label && <span className="text-[10px] text-[#8C6208] font-bold">{label}</span>}
      <span className="text-[10px] font-semibold">Rp {fmt(value || 0)}</span>
      {suffix && <span className="text-[10px] text-muted-foreground">{suffix}</span>}
      <button className="text-slate-400 group-hover:text-[#8C6208] opacity-0 group-hover:opacity-100 transition-opacity p-0.5" title="Edit Harga Jual">
        <Edit2 className="w-3 h-3" />
      </button>
    </div>
  );
}
